// import React from 'react';
// import { Typography, Row, Col, Space } from 'antd';
import forest_image from './images/home_forest.jpeg';
// import cwi_image from './images/cwi_full_logo.png';
// import interagency_treatment from './images/interagency_treatment.png';
// import cwi_small_logo from './images/cropped-CWFRTF_logo.png';
// import Carousel from './components/carousel/Carousel';
import { FaLink } from 'react-icons/fa6';
import { Button, Col, Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import './Home.css';

// const { Title } = Typography;
const Home = () => {
  const navigate = useNavigate();
  const steps = [
    {
      title: 'Measure',
      text: 'Data originates from diverse sources across the state: local parcel and community data, completed treatments reported by all ownerships, planned treatments in five-year programs of work, wildfire incident records, and landscape observations from remote sensing and field inventory.',
    },
    {
      title: 'Steward',
      text: 'Partner systems maintain authoritative datasets within their domains.',
    },
    {
      title: 'Share',
      text: 'The CA Data Commons federates these stewarded datasets into a unified hub with consistent metadata, reusable and extensible APIs, and standardized access.',
    },
    {
      title: 'Report',
      text: 'Dashboards and applications transform shared data into actionable information.',
    },
  ];
  return (
    <div style={{ backgroundColor: '#FDFEF5', height: '100%' }}>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div
          className="home-hero"
          style={{
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'left',
            padding: 40,
            backgroundColor: '#e3ebe8',
            backgroundImage: `url(${forest_image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
            backgroundBlendMode: 'multiply',
            width: '100%',
            height: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              width: '100%',

              padding: '1% 0 ',
            }}
          >
            <div style={{ marginRight: '5%', minWidth: 0 }}>
              <h1
                style={{
                  color: '#2B2B2B',
                  textAlign: 'left',
                  fontWeight: 'bold',
                  fontSize: 36,
                  paddingBottom: '1%',
                }}
              >
                California Wildfire Commons
              </h1>
              <p
                className="home-intro"
                style={{
                  color: '#2B2B2B',
                  textAlign: 'left',
                  fontWeight: 'normal',
                  fontSize: 28,
                  maxWidth: '1000px',
                }}
              >
                The California Wildfire Commons, a node of the Wildfire Science
                and Technology Commons, is emerging as California’s unified
                platform to catalog, find, view, and use data and tools about
                wildfire risk, treatments, fuels, weather, measurements, fire
                behavior, and outcomes. Grounded in open-science principles, it
                federates datasets, models, and tools so that existing
                investments become discoverable, interoperable, and available to
                all stakeholders.{' '}
                <Button
                  type="link"
                  className="home-intro-link"
                  style={{ padding: 0, fontSize: 28, color: '#996B00' }}
                  onClick={() => {
                    navigate('/about');
                  }}
                  aria-label="Learn more about California Wildfire Commons"
                >
                  Learn more
                </Button>
                .
              </p>
              <div
                style={{
                  width: '100%',
                  maxWidth: '1200px',
                  margin: '40px 0',
                  backgroundColor: '#f9f7eb', // Slightly lighter for better text contrast
                  borderRadius: '12px',
                  border: '2px solid #2B2B2B', // Shorthand for width, style, and color
                  padding: '24px',
                }}
              >
                <h4
                  style={{
                    color: '#2C3E37',
                    marginBottom: '24px',
                    textAlign: 'center',
                  }}
                >
                  <strong>
                    The California Wildfire Commons organizes information needs
                    around four core functions:
                  </strong>
                </h4>

                <div
                  className="home-steps"
                  style={{
                    display: 'flex',
                    alignItems: 'stretch',
                    gap: '4px', // Small gap to show the "cut"
                    width: '100%',
                  }}
                >
                  {steps.map((step, index) => {
                    const isFirst = index === 0;
                    const isLast = index === steps.length - 1;

                    return (
                      <div
                        key={step.title}
                        className="home-step"
                        style={{
                          flex: 1,
                          backgroundColor: '#E3B448',
                          position: 'relative',
                          padding: '20px 30px 20px 40px',
                          // This creates the arrow shape
                          clipPath: isFirst
                            ? 'polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%)'
                            : isLast
                              ? 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 10% 50%)'
                              : 'polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%, 10% 50%)',
                          marginLeft: isFirst ? 0 : '-15px', // Overlap for the "slot" effect
                          transition: 'transform 0.2s ease',
                          cursor: 'default',
                        }}
                      >
                        <h4
                          style={{
                            color: '#3a3b26',
                            fontWeight: '800',
                            fontSize: '1.1rem',
                            marginTop: 0,
                            marginBottom: '8px',
                          }}
                        >
                          {step.title}
                        </h4>
                        <p
                          style={{
                            margin: 0,
                            fontSize: '13px',
                            lineHeight: '1.4',
                            color: '#2d3748',
                          }}
                        >
                          {step.text}
                        </p>
                      </div>
                    );
                  })}
                </div>
                <h5
                  style={{
                    color: '#2C3E37',
                    marginBottom: '24px',
                    textAlign: 'center',
                    padding: '8px 0',
                    margin: 0,
                  }}
                >
                  This framework ensures that every dataset has a clear path
                  from collection to use,
                  <br /> with defined stewardship responsibilities and quality
                  standards at each step.
                </h5>
              </div>
            </div>
          </div>
          <h5
            style={{
              color: 'white',
              textAlign: 'left',
              fontWeight: 'bolder',
              fontSize: '30px',
            }}
          >
            Explore datasets, tools and analysis
          </h5>
          <div className="home-grid" style={{ maxWidth: '1200px' }}>
            <Row gutter={16} style={{ marginBottom: '16px' }}>
              <Col span={12} flex="1 1 0">
                <Button
                  onClick={() => {
                    navigate('/catalog');
                  }}
                  type="text"
                  icon={<FaLink size={20} color="#2C3E37" />}
                  className="gridButton"
                >
                  <h4 className="gridButtonText">Explore Data Catalog</h4>
                </Button>
              </Col>
              <Col span={12} flex="1 1 0">
                <Button
                  onClick={() => {
                    navigate('/mapviewer');
                  }}
                  type="text"
                  icon={<FaLink size={20} color="#2C3E37" />}
                  className="gridButton"
                >
                  <h4 className="gridButtonText">Explore Map Viewer</h4>
                </Button>
              </Col>
            </Row>
            <Row gutter={16} style={{ marginBottom: '16px' }}>
              <Col span={12} style={{ minWidth: 0 }}>
                <Button
                  onClick={() => {
                    window.open(
                      'https://interagencytrackingsystem.org/',
                      '_blank',
                      'noopener,noreferrer'
                    );
                  }}
                  type="text"
                  icon={<FaLink size={20} color="#2C3E37" />}
                  className="gridButton"
                >
                  <h4 className="gridButtonText">
                    Explore Interagency Treatment Dashboard
                  </h4>
                </Button>
              </Col>
              <Col span={12} style={{ minWidth: 0 }}>
                <Button
                  onClick={() => {
                    window.open(
                      'https://caregionalresourcekits.org/clm.html',
                      '_blank',
                      'noopener,noreferrer'
                    );
                  }}
                  type="text"
                  icon={<FaLink size={20} color="#2C3E37" />}
                  className="gridButton"
                >
                  <h4 className="gridButtonText">
                    Explore California Landscape Metrics
                  </h4>
                </Button>
              </Col>
            </Row>
            {/* <Row gutter={16}>
              <Col span={12} style={{ paddingRight: '8px' }}>
                <Button
                  onClick={() => {
                    navigate('/workspace');
                  }}
                  type="text"
                  icon={<FaLink size={20} color="#2C3E37" />}
                  className="gridButton"
                >
                  <h4 className="gridButtonText">Explore Public Workspaces</h4>
                </Button>
              </Col>
            </Row> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
